import { DateTime } from 'luxon'
import { Helmet } from 'react-helmet-async'

import { makeStyles } from '@material-ui/core/styles'

import { PLACEHOLDER_PHOTO_PATH } from 'config/app.config'
import { useRoster } from 'hooks/useRoster'
import { sortRosterTutors } from 'utils/roster'

const useStyles = makeStyles(
  theme => ({
    root: {
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      background: theme.palette.gradientBackground,
      padding: theme.spacing(2),
      alignItems: 'center',
    },

    title: {
      textTransform: 'uppercase',
      fontWeight: 'bold',
      marginBottom: theme.spacing(0.3),
    },

    roster: {
      display: 'flex',
      flex: 1,
      justifyContent: 'center',
      flexDirection: 'row',
      flexWrap: 'wrap',
    },

    rosterProfile: {
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      alignItems: 'center',
      marginBottom: theme.spacing(0.3),
    },

    name: {
      textTransform: 'uppercase',
      fontWeight: 'bold',
    },

    imageContainer: {
      height: '20vh', // must be height number, or placeholder will be too wide
    },

    photo: {
      // ...getProfileContainerStyles(theme),
      height: '100%', // must be height 100%
    },
  }),
  { name: 'PhotoRoster' }
)

export const PhotoRoster = () => {
  const classes = useStyles()

  // Tutors from recruit-next and their photos from TA Draft, via this app's signed endpoint
  const { data: roster, isLoading: rosterLoading, error: rosterError } = useRoster()

  const tutors = sortRosterTutors(roster?.tutors || [])

  return (
    <div className={classes.root}>
      <Helmet>
        <title>TA Photo Roster {DateTime.now().toFormat('yyyy-MM-dd HH:mm:ss')}</title>
      </Helmet>
      <div className={classes.title}>Computer Science Tutors</div>
      <div className={classes.roster}>
        {rosterLoading ? (
          <>loading</>
        ) : rosterError ? (
          <>{rosterError.message}</>
        ) : (
          tutors.map((tutor, index) => {
            // TA Draft already looked the photo up (null when there is none on file)
            const image = `${roster?.photoBaseUrl}/${tutor.photo || PLACEHOLDER_PHOTO_PATH}`

            return (
              <div key={index}>
                <div className={classes.rosterProfile}>
                  <div className={classes.imageContainer}>
                    <img className={classes.photo} src={image} alt={tutor.firstName} />
                  </div>
                  <div className={classes.name}>{tutor.nickname || tutor.firstName}</div>
                </div>
              </div>
            )
          })
        )}
      </div>
    </div>
  )
}
